"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partition = void 0;
var __1 = require("../..");
var constants_1 = require("../../../specs/constants");
var spec_factory_1 = require("../../../state/spec_factory");
var config_1 = require("../layout/config");
var config_types_1 = require("../layout/types/config_types");
var group_by_rollup_1 = require("../layout/utils/group_by_rollup");
var defaultProps = {
    chartType: __1.ChartType.Partition,
    specType: constants_1.SpecType.Series,
    valueAccessor: function (d) { return (typeof d === 'number' ? d : 0); },
    valueGetter: function (n) { return n[group_by_rollup_1.AGGREGATE_KEY]; },
    valueFormatter: function (d) { return String(d); },
    percentFormatter: config_1.percentFormatter,
    topGroove: 20,
    smallMultiples: null,
    layers: [
        {
            groupByRollup: function (d, i) { return i; },
            nodeLabel: function (d) { return String(d); },
            showAccessor: function () { return true; },
            fillLabel: {},
        },
    ],
    clockwiseSectors: true,
    specialFirstInnermostSector: true,
    layout: config_types_1.PartitionLayout.sunburst,
    drilldown: false,
    maxRowCount: 12,
    fillOutside: false,
    radiusOutside: 128,
    fillRectangleWidth: Infinity,
    fillRectangleHeight: Infinity,
};
exports.Partition = (0, spec_factory_1.getConnect)()((0, spec_factory_1.specComponentFactory)(defaultProps));
//# sourceMappingURL=index.js.map